import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import CustomItemStatus from "../../../../../../common/components/custom_item_status";


type Props = {
    onActionEdit: (idEntregaObras: number | null, openState: boolean) => void,
    onActionDelete: (idEntregaObras: number | null, openState: boolean) => void,
    onActionItens: (idEntregaObras: number | null, openNewTab: boolean) => void,
}

export const GenerateEntregaObrasColumns = ({
    onActionEdit,
    onActionDelete,
    onActionItens

}: Props): GridColDef[] => {
    const computeStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Em Aberto";
            case 1:
                return "Entregue";
            default:
                return "?";
        }
    };

    const computeStatusColor = (status: number) => {
        switch (status) {
            case 0:
                return "#c6c6c6";
            case 1:
                return "#45b6af";
            default:
                return "#0303FF";
        }
    };

    const computeStatusDescription = (status: number) => {
        switch (status) {
            case 0:
                return "Em Aberto";
            case 1:
                return "Entregue";
            default:
                return "?";
        }
    };

    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 100,
            width: 120,
            maxWidth: 150,
            sortable: false,
            valueGetter: (_, row) => ({
                status: row['status'] as number,
            }),
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-center items-center gap-2">
                    <CustomItemStatus
                        size="autowidth"
                        textSize="small"
                        title={computeStatusTitle(value.status)}
                        bgColor={computeStatusColor(value.status)}
                        description={computeStatusDescription(value.status)} />
                </div>
            )
        },
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro de Custo",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "vistorias",
            filterable: false,
            headerName: "Vistorias",
            minWidth: 120,
            maxWidth: 120,
            sortable: false,
            valueGetter: (_, row) => ({
                idEntregaObra: row['idEntregaObra'] as number,
            }),
            renderCell: ({ value }) =>
                <Button
                    onMouseDown={() => onActionItens(value.idEntregaObra, true)}
                    sx={{
                        fontSize: 11,
                        paddingX: '.4rem',
                        paddingY: 0,
                        background: '#e6e6e6',
                        borderLeft: '.2rem solid #45b6af',
                        borderRadius: 0,
                        color: 'black',
                        fontWeight: 'normal',
                    }}>
                    Vistorias
                </Button>
        },
        {
            field: "satisfacaoCliente",
            filterable: false,
            headerName: "Satisfação do Cliente",
            flex: 1,
            minWidth: 150,
            maxWidth: 150,
            sortable: false,
            renderCell: ({ value }) => <span>{value * 100}%</span>
        },
        {
            field: 'idEntregaObra',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 180,
            width: 180,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton
                            onClick={() => onActionEdit(params.value, true)}
                        >
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}